import { render, staticRenderFns } from "./UserAddIcon.vue?vue&type=template&id=da9f92c6"
import script from "./UserAddIcon.vue?vue&type=script&lang=js"
export * from "./UserAddIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports